// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Dealersignup from "./pages/Dealersignup";
import Gallery from "./pages/Gallery";
import DealerMap from "./pages/DealerMap";

// NEW
import BrowseColors from "./pages/BrowseColors";
import ColorDetail from "./pages/ColorDetail";

export default function App() {
  return (
    <div className="min-h-screen bg-black text-neutral-100 flex flex-col">
      <Header />

      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/dealersignup" element={<Dealersignup />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/dealer-map" element={<DealerMap />} />
	  <Route path="/colors" element={<BrowseColors />} />
          <Route path="/colors/:slug" element={<ColorDetail />} />

          {/* Fallback */}
          <Route path="*" element={<Home />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
